module.exports = "../img/gake_new_lg.png";


//////////////////
// WEBPACK FOOTER
// ./client/img/gake_new_lg.png
// module id = 11
// module chunks = 6